import Navigation from '@/components/Navigation';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navigation />
      
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-['Outfit'] text-4xl font-bold mb-8">Privacy Policy</h1>
        <div className="prose prose-invert max-w-none">
          <p className="text-gray-400 mb-8">Last Updated: February 1, 2026</p>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">1. Introduction</h2>
            <p className="text-gray-300 mb-4">
              Negotiation Ninja AI ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">2. Information We Collect</h2>
            
            <h3 className="font-['Outfit'] text-xl font-semibold mb-3 text-green-400">2.1 Personal Information</h3>
            <p className="text-gray-300 mb-4">When you create an account via Google OAuth, we collect:</p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>Name</li>
              <li>Email address</li>
              <li>Profile picture (from Google)</li>
              <li>Google account ID</li>
            </ul>

            <h3 className="font-['Outfit'] text-xl font-semibold mb-3 text-green-400">2.2 Usage Data</h3>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>Roleplay session data (scenarios, messages, scores)</li>
              <li>Generated scripts and win logs</li>
              <li>Challenge completions and streaks</li>
              <li>Subscription status and payment history</li>
            </ul>

            <h3 className="font-['Outfit'] text-xl font-semibold mb-3 text-green-400">2.3 Technical Data</h3>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>Session cookies</li>
              <li>Usage analytics (pages visited, features used)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">3. How We Use Your Information</h2>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li><strong>Provide the Service:</strong> Enable AI roleplays, script generation, and tracking</li>
              <li><strong>Process Payments:</strong> Handle subscriptions via Stripe</li>
              <li><strong>Improve the Service:</strong> Analyze usage patterns to enhance features</li>
              <li><strong>Communication:</strong> Send service updates, security alerts, and marketing (opt-out available)</li>
              <li><strong>Security:</strong> Detect and prevent fraud or abuse</li>
              <li><strong>Legal Compliance:</strong> Meet legal obligations and enforce Terms</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">4. Data Sharing and Disclosure</h2>
            <p className="text-gray-300 mb-4">We do NOT sell your personal data. We may share data with:</p>
            
            <h3 className="font-['Outfit'] text-xl font-semibold mb-3 text-green-400">4.1 Service Providers</h3>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li><strong>Stripe:</strong> Payment processing</li>
              <li><strong>OpenAI:</strong> AI model hosting (anonymized data)</li>
              <li><strong>MongoDB Atlas:</strong> Database hosting</li>
              <li><strong>Google OAuth:</strong> Authentication</li>
            </ul>

            <h3 className="font-['Outfit'] text-xl font-semibold mb-3 text-green-400">4.2 Legal Requirements</h3>
            <p className="text-gray-300 mb-4">
              We may disclose your information if required by law, court order, or to protect our rights and safety.
            </p>

            <h3 className="font-['Outfit'] text-xl font-semibold mb-3 text-green-400">4.3 Business Transfers</h3>
            <p className="text-gray-300 mb-4">
              In the event of a merger, acquisition, or sale, your data may be transferred to the new entity.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">5. Data Security</h2>
            <p className="text-gray-300 mb-4">We implement industry-standard security measures:</p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>HTTPS encryption for all data transmission</li>
              <li>Encrypted database connections</li>
              <li>Secure session management (httpOnly cookies)</li>
              <li>Regular security audits</li>
              <li>Access controls and authentication</li>
            </ul>
            <p className="text-gray-300 mb-4">
              However, no method of transmission over the Internet is 100% secure. We cannot guarantee absolute security.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">6. Your Rights (GDPR & UK Data Protection)</h2>
            <p className="text-gray-300 mb-4">Under GDPR and UK data protection laws, you have the right to:</p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Rectification:</strong> Correct inaccurate data</li>
              <li><strong>Erasure:</strong> Request deletion of your data ("right to be forgotten")</li>
              <li><strong>Portability:</strong> Receive your data in a machine-readable format</li>
              <li><strong>Object:</strong> Object to data processing for marketing purposes</li>
              <li><strong>Restrict Processing:</strong> Limit how we use your data</li>
              <li><strong>Withdraw Consent:</strong> Opt out of optional data processing</li>
            </ul>
            <p className="text-gray-300 mb-4">
              To exercise these rights, email us at guniboparai@gmail.com
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">7. Cookies and Tracking</h2>
            <p className="text-gray-300 mb-4">We use cookies for:</p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li><strong>Essential Cookies:</strong> Session management, authentication (required)</li>
              <li><strong>Analytics Cookies:</strong> Google Analytics for usage tracking (optional)</li>
              <li><strong>Performance Cookies:</strong> Service optimization</li>
            </ul>
            <p className="text-gray-300 mb-4">
              You can disable non-essential cookies in your browser settings. Note that this may limit functionality.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">8. Data Retention</h2>
            <p className="text-gray-300 mb-4">We retain your data for:</p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li><strong>Active Accounts:</strong> Duration of account + 90 days after cancellation</li>
              <li><strong>Payment Records:</strong> 7 years (legal requirement)</li>
              <li><strong>Analytics Data:</strong> 26 months (aggregated, anonymized)</li>
            </ul>
            <p className="text-gray-300 mb-4">
              After retention periods, data is securely deleted or anonymized.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">9. Children's Privacy</h2>
            <p className="text-gray-300 mb-4">
              The Service is not intended for users under 16 years old. We do not knowingly collect data from children. If you believe a child has provided us with personal data, contact us immediately.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">10. International Data Transfers</h2>
            <p className="text-gray-300 mb-4">
              Your data may be processed in countries outside the UK/EU (e.g., US-based servers for MongoDB, OpenAI). We ensure adequate safeguards through:
            </p>
            <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2">
              <li>Standard Contractual Clauses (SCCs)</li>
              <li>Data Processing Agreements with vendors</li>
              <li>Compliance with GDPR Article 46</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">11. Changes to This Policy</h2>
            <p className="text-gray-300 mb-4">
              We may update this Privacy Policy periodically. Changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy regularly.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">12. Contact Us</h2>
            <p className="text-gray-300 mb-4">
              For privacy-related questions or to exercise your rights:
            </p>
            <p className="text-gray-300">
              Email: guniboparai@gmail.com<br />
              Data Protection Officer: guniboparai@gmail.com<br />
              Website: https://ninjaninja.co
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-['Outfit'] text-2xl font-bold mb-4">13. Supervisory Authority</h2>
            <p className="text-gray-300 mb-4">
              If you are unhappy with how we handle your data, you have the right to lodge a complaint with:
            </p>
            <p className="text-gray-300">
              Information Commissioner's Office (ICO)<br />
              Website: https://ico.org.uk<br />
              Phone: 0303 123 1113
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;